import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Box, TableContainer, Typography, Select, MenuItem, Popover } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import useStyles from './style'
import Pagination from '@material-ui/lab/Pagination'
import { InfoOutlined } from '@material-ui/icons'
import { SORTORDER } from './constants'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'

const TableContents = (props) => {
  const { tableHeadings, tableContents, pageSize, setPageSize, setPageNo, pageNo, sortBy, count } = {...props}
  const classes = useStyles()
  const pagesizes = [15, 30, 100];
  const [page, setPage] = useState(pageNo+1)
  const [isBold, setIsBold] = useState('')
  const [counter, setCounter] = useState(count)
  const [anchorEl, setanchorEl] = useState(null)
  const [activeHeaderId, setActiveHeaderId] = useState(null)

  useEffect(() => {
    setPage(pageNo+1)
  }, [pageNo])

  useEffect(() => {
    setCounter(count)
  }, [count])

  useEffect(() => {
    setIsBold(sortBy)
  }, [sortBy])

  const handleClose = () => {
    setanchorEl(null)
    setActiveHeaderId(null)
  }

  const handleInfoClick = ( event, id ) => {
    setanchorEl(event.currentTarget)
    setActiveHeaderId(id)
  }

  const popOverContent = (id) => {
    switch (id) {
      case "totalRequests":
        return "Total number of API calls received in the selected time period"
      // case "uptime":
      //   return "Successful Requests (%) = [(Total number of Requests – 5xx errors) ÷ total number of Requests] × 100"
      case "total2XXSuccess":
        return "Requests that completed successfully."
      case "totalErrors":
        return "Number of API requests that failed due to client or server errors (4xx and 5xx responses)"
      case "errorPercentage":
        return "Percentage of total API requests that resulted in client or server errors (4xx and 5xx responses)"
      case "total400Errors":
        return "Requests that failed due to invalid or malformed input."
      // case "total401Errors": 
      //   return "Requests rejected because authentication was missing or expired."
      case "total403Errors":
        return "Requests denied due to insufficient permissions." 
      case "total404Errors":
        return "Requests for resources that do not exist."
      case "total422Errors":
        return "Requests that failed due to invalid or unprocessable data."
      case "total5XXErrors":
        return "Requests that failed due to server-side issues."
      default:
        return ""
    }
  };

  const openPopover = Boolean(anchorEl)
  const id = openPopover ? 'simple-popover' : undefined

  return (
    <Box>
      <TableContainer className={classes.table} component={Paper}>
        <Table stickyHeader>
          <TableHead >
            {(tableHeadings.map((item, index) => (
              <TableCell className={classes.tableHeader}>
                <Box display='flex' >
                  <span className={(item.id === isBold) ? classes.isBold : ''}>{item.label}</span>
                    {item.id !== 'apiURL' && <>
                      <Box className={classes.sortIcon} >
                        {item.id === isBold ?                    
                          <Box className={classes.sortContainer}>
                            <ArrowDropUpIcon
                              className={`${classes.sortUp} ${
                                item.sortOrder === SORTORDER.ASC ? classes.active : classes.inactive
                              }`}
                              fontSize="small"
                              onClick={() => props.handleSortChange(item.id, SORTORDER.ASC)}
                            />
                            <ArrowDropDownIcon
                              className={`${classes.sortDown} ${
                                item.sortOrder === SORTORDER.DESC ? classes.active : classes.inactive
                              }`}
                              fontSize="small"
                              onClick={() => props.handleSortChange(item.id, SORTORDER.DESC)}
                            />
                          </Box> : 
                          <Box className={classes.sortContainer}>
                            <ArrowDropUpIcon
                              className={`${classes.sortUp} ${classes.inactive}`}
                              fontSize="small"
                              onClick={() => props.handleSortChange(item.id, SORTORDER.ASC)}
                            />

                            <ArrowDropDownIcon
                              className={`${classes.sortDown} ${classes.inactive}`}
                              fontSize="small"
                              onClick={() => props.handleSortChange(item.id, SORTORDER.DESC)}
                            />
                          </Box>
                        }
                      </Box>
                      <span><InfoOutlined className={classes.infoIcon} onClick={(e) => handleInfoClick(e, item.id)} /></span>
                    </>
                  }
                  <Popover 
                    id={id}
                    anchorEl={anchorEl}
                    open={openPopover}
                    classes={{ paper: classes.popper }}
                    onClose={handleClose}
                  >{popOverContent(activeHeaderId)}</Popover>
                </Box>
              </TableCell>
            )))}
          </TableHead>
          <TableBody>
            {(tableContents?.overallSummary?.map((item, index) => (
              <TableRow >
                {(tableHeadings.map((obj) => (
                  <TableCell key={obj.id} classes={{ root: classes.tableCell }}>
                    {(obj.id === 'apiURL' ? 'Total' : item[obj.id] ? new Intl.NumberFormat('en-US').format(item[obj.id]) : 0)}
                  </TableCell>
                )))}
              </TableRow>
            )))}
            {(tableContents?.apiMetrics?.map((item, index) => (
              <TableRow>
                {tableHeadings.map((obj) => (
                  <TableCell>
                    {obj.id === 'apiURL' ? item[obj.id] : new Intl.NumberFormat('en-US').format(item[obj.id])}
                  </TableCell>
                ))}
              </TableRow>
            )))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box style={{display: 'flex', alignItems: 'center'}}>
          <Typography style={{marginRight: '20px'}}>Rows Per Page</Typography>
          <Select 
            value={pageSize}
            onChange={(e)=> (setPageSize(e.target.value), setPageNo(0))}>
            {pagesizes.map((value) => (
              <MenuItem value={value} onChange={(e) => setPageSize(e.target.value)}>{value}</MenuItem>
            ))}
          </Select>
        </Box>
        <Pagination 
          page={page}
          count={counter}
          shape="rounded"
          onChange={(event, newPage) => { page !== newPage && props.handleChangePage(newPage) }}
        />
      </Box>
    </Box>
   )
}
export default TableContents;